export { CustomerRegisterFormView as CustomerRegisterForm } from './CustomerRegisterForm.view'
export { CustomerRegistrationFormValues } from './CustomerRegisterForm.model'
export * from './CustomerRegisterForm.validators'



// WEBPACK FOOTER //
// ./src/views/components/Forms/CustomerRegisterForm/index.ts